import { nav } from "src/global";
import { fixDateValue } from "src/utils";

const isSupportBeacon = !!nav.sendBeacon;


// 使用beacon上报数据
function sendBeacon(url, data) {
  return nav.sendBeacon(url, data);
}

// 使用xhr上报数据
function sendXhr(url, data) {
  const xhr = new XMLHttpRequest();
  xhr.open('post', url, true);
  xhr.withCredentials = false;
  xhr.setRequestHeader("content-type", "text/plain");
  xhr.send(data);
  return xhr;
}

function sendImg() {}

interface ResData {
  [key: string]: EventMessage[]
}
/**
 * 上报数据，将成品数据进行发送上报
 */
export default function reporter(url: string, eventMessages: EventMessage[]) {
  // hbLogger.info('reporter eventMessages', eventMessages.length);
  if(!url) return;
  try {
    const rData: ResData = {};
    const others = [];
    const now = fixDateValue(Date.now());
    eventMessages.forEach(item => {
      const code = item.header.servicecode;
      item.header.ert = now;
      if(code) {
        const codeData = rData[code] || [];
        codeData.push(item);
        rData[code] = codeData;
      } else {
        others.push(item);
      }
    });
    if(others.length > 0) {
      rData.unknown = others;
    }
    const reportData = JSON.stringify(rData);
    let reportRet = false;
    const strSize = reportData.length;
    if(isSupportBeacon && strSize < 30000) {
      reportRet = sendBeacon(url, reportData);
    } else {
      reportRet = !!sendXhr(url, reportData);
    }
  } catch (err) {
    hbLogger.warn(err);
  }
}
